package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

interface InverterSelection : HasUuid {
  val id: InverterSelectionId

  override val uuid: Uuid
    get() = id.uuid

  @Serializable
  data class InverterSelectionId(val uuid: NativeUuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): InverterSelectionId {
        return InverterSelectionId(randomUuid4())
      }
    }
  }
}
